/**
 *
 * @param {Model} handler Model to handle the data fetching
 * @param {Object} options Object with options to customize the data fetching
 * @example
 * let options = {
 *      includes: ['stocks', 'sale_prices'],
 *      appends: ['some_append'],
 *      filters: [
 *          wh_family_id: [3, 4],
 *          otro_filtro: 'algo'
 *      ],
 *      pagination: {
 *          page: 2,
 *          rowsPerPage: 15,
 *          orderBy: null,
 *          descending: null
 *      }
 *      // Function for processing data before returning it
 *      formatter: null
 *  
 * }
 */
const fetch = async (
    handler,
    options = {
        includes: [],
        appends: [],
        filters: [],
        pagination: null,
        formatter: null,
        options: null,
    }
) => {
    let response = await fetchByModel(handler, options)
    return response
}

const fetchByModel = async (model, options) => {
    if (options.includes && options.includes.length > 0) {
        model = model.include(...options.includes)
    }
    if (options.appends && options.appends.length > 0) {
        model = model.append(...options.appends)
    }
    if (options.params) {
        model = model.params(options.params)
    }
    if (options.filters && options.filters.length > 0) {
        options.filters.forEach(filter => {
            if (filter.value.constructor === Array) {
                model = model.whereIn(filter.field, filter.value)
            } else {
                model = model.where(filter.field, filter.value)
            }
        })
    }
    if (options.pagination) {
        if (options.pagination.page) {
            model = model.page(options.pagination.page)
        }
        if (options.pagination.sortBy) {
            model = model.orderBy(
                (options.pagination.descending ? '-' : '') +
                    options.pagination.sortBy
            )
        }
        if (options.pagination.rowsPerPage) {
            model = model.limit(options.pagination.rowsPerPage)
        }
    }
    let response = await model.get()
    if (options.formatter) response = options.formatter(response)
    return response
}

// const fetchByUrl = ()

export { fetch }
